angular.module('bmsApp.directives')
	.directive('pipelineFields', function () {
		return {
			restrict: 'E',
			replace: false,
			scope: {ngModel: '='},
			templateUrl: 'ng/shared/directives/stack0/pipeline-fields/pipelineFields.html',
			link: function (scope, element, attrs) {

			},
			controller: "pipelineFieldsCtrl"

		};
	})
	.controller('pipelineFieldsCtrl', function ($scope, $timeout) {

		function init() {
			console.log($scope);
			$timeout(function () {
				$scope.$broadcast('rzSliderForceRender');
			}, 500);
		}


		var self = $scope.PipelineFieldsCtrl = {
			methods: {
				init: init
			},
			sliderOptions: {
				disabled: false,
				floor: 0,
				ceil: 100,
				step: 5,
				translate: function (value, sliderId, label) {
					return value + '%';
				}
			}
		}
	});
